module.exports = __webpack_public_path__ + "media/images/pages/peel-59f6ddef0b4b720cdbd27a390c0cf541.png";